import HttpClient from "../http/http_client";
export const getUmpireDetailRequest = async () => {
    try {
        const resposne = await HttpClient.get('umpire-details/');
        return {
            success : true,
            data : resposne.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
    }
}
